// extracted by mini-css-extract-plugin
module.exports = {"subHeader":"resetPassword_subHeader__3qx4r","circle":"resetPassword_circle__35iPF","title":"resetPassword_title__20W5f","form":"resetPassword_form__1_vHY"};